export const getAnnexeList = resp => {
  return {
    type: "FETCH_ANNEXE_LIST",
    payload: resp
  };
};

export const initAnnexeList = () => {
  return {
    type: "INIT_ANNEXE_LIST"
  };
};

export const selectAnnexeListCategory = category => {
  return {
    type: "SELECT_ANNEXE_LIST_CATEGORY",
    category
  };
};

export const selectAnnexeType = element => {
  return {
    type: "SELECT_ANNEXE_TYPE",
    element
  };
};

export const selectAnnexeListFileName = fileName => {
  return {
    type: "SELECT_ANNEXE_LIST_FILENAME",
    fileName
  };
};

export const selectAnnexeListYear = year => {
  return {
    type: "SELECT_ANNEXE_LIST_YEAR",
    year
  };
};

export const setAnnexeListPaginationPage = pageNumber => {
  return {
    type: "SET_ANNEXE_LIST_PAGINATION_PAGE",
    pageNumber
  };
};

export const setAnnexeListPageSize = pageSize => {
  return {
    type: "SET_ANNEXE_LIST_PAGE_SIZE",
    pageSize
  };
};

export const getAnnexeTemporaryLink = resp => {
  return {
    type: "FETCH_ANNEXE_TMP_LINK",
    payload: resp
  };
};

export const setAnnexeTemporaryLink = link => {
  return { type: "SET_ANNEXE_TMP_LINK", link };
};

export const deleteAnnexe = resp => ({
  type: "DELETE_ANNEXE",
  payload: resp
});

export const setMainAnnexe = resp => ({
  type: "SET_MAIN_ANNEXE",
  payload: resp
});

export const toggleHiddenAnnexe = resp => ({
  type: "TOGGLE_HIDDEN_ANNEXE",
  payload: resp
});

export const toggleCertifiedAnnexe = resp => ({
  type: "TOGGLE_CERTIFIED_ANNEXE",
  payload: resp
});

export const setAnnexeList = items => {
  return {
    type: "SET_ANNEXE_LIST",
    items
  };
};

export const getBalanceSheetAttachments = resp => {
  return {
    type: "FETCH_BALANCE_SHEET_ATTACHMENTS",
    payload: resp
  };
};

export const initBalanceSheetAttachments = () => {
  return {
    type: "INIT_BALANCE_SHEET_ATTACHMENTS"
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/annexe.js